function isInViewport(el) {
  const { top, bottom } = el.getBoundingClientRect();
  var imageHeight = el.querySelector(".product-image img").clientHeight;
  if (((window.innerHeight / 2) - (imageHeight / 2)) > top && bottom > 0) {
    el.querySelector(".product-image img").classList.add("reveal");
  }
}
function animateNums(parentElem, childElem){
  document.querySelectorAll(parentElem).forEach(section => {
    var position = section.querySelector(childElem).getBoundingClientRect();
    var imageHeight = section.querySelector(".product-image img").clientHeight;
    if(position.top >= 0 && position.top <= ((window.innerHeight / 2) + imageHeight) && section.querySelector(".product-image img").classList.contains("reveal")) {
        section.querySelectorAll('.animated-number').forEach(element => {            
            if(!element.classList.contains('active')){
                element.querySelectorAll('.animated-number_item').forEach(elem2 => {
                    let digitHeight = elem2.clientHeight,
                        digitElement = elem2.querySelector('.animated-number_digits'),
                        childCount = digitElement.childElementCount,
                        animatCalc = digitHeight * (childCount-1);
                    
                    digitElement.style.transform = 'translate(0, -'+animatCalc+'px)';
                });
                element.classList.add('active');
            }
        })
    }
  });
}
window.onload = window.onscroll = (event) => {
  document.querySelectorAll(".collection-product-card").forEach(function(card) {
    if(card && card.querySelector(".product-image img") && !card.querySelector(".product-image img").classList.contains("reveal")) isInViewport(card);
  })
  animateNums('.collection-product-card', '.product-specification');
}